var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.isLoading)?_c('PreLoader',{staticClass:"animate__animated animate__zoomIn"}):_vm._e(),_c('LoginForm',{attrs:{"userLogin":_vm.userLogin},on:{"login":function($event){return _vm.login()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }